export const dynamicPageGoalsMap: { [key: string]: string } = {
  leads: 'Collect leads',
  appDownload: 'App download',
  calendly: 'Meeting via Calendly',
  linkClick: 'Link click',
  assetDownload: 'Asset download',
  demoRequest: 'Demo request',
  ecourseRegistration: 'ECourse registration',
  enrollment: 'Enrollment application',
  eventRegistration: 'Event registration',
  productSale: 'Product sales',
  scheduleAppointment: 'Schedule appointment',
  signup: 'Signup',
  webinar: 'Webinar registration',
};
